import React from 'react'

import { PREFERENCE_OPTIONS } from 'constants/user'

import Label from './Label'
import GenderSelect from './GenderSelect'

const InputPreferences = ({ onChange, userData }) => (
  <div>
    <Label htmlFor="test">Preferences</Label>
    <GenderSelect
      name="genders"
      defaultLabel="Looking for"
      fullOptionsTitle="My Interests"
      moreLabel="Multiple"
      options={PREFERENCE_OPTIONS}
      onChange={onChange}
      value={userData.preference?.genders || []}
      multiSelect
    />
  </div>
)

export default InputPreferences
